export default __webpack_public_path__ + "static/media/88b8813926eca118.d8997b2992110a507ed4568a95fbafd7.svg";